import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import { FlexColContainer, FlexRowContainer } from 'components/StyledComp';
import CustomButton from 'components/CustomButton';
import ChangeHistoriesButton from 'components-desktop/histories/ChangeHistoriesButton';
import PatientMasterweek from './PatientMasterweek';

const propTypes = {
  contracts: PropTypes.array.isRequired,
  servicesByCompany: PropTypes.object.isRequired,
  onDeleteMasterweekSuccess: PropTypes.func.isRequired,
  onUpdateMasterweekSuccess: PropTypes.func.isRequired,
};

@autobind
class PatientMasterweeks extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      adding: false,

      tableKey: null,
      masterweeks: [],
      caregivers: [],
    };
  }

  componentDidMount() {
    this.id = this.parseQueryParam('id', this.props.location);
    this.getPatientMasterweeksAndOtherDetails();
  }

  async getPatientMasterweeks() {
    const params = { patientId: this.id };
    const masterweeks =
        await this.callServiceForRemoteObjects('/masterweek/get_list_for_patient_profile', params);

    this.setState({
      tableKey: `${Date.now()}_${Math.random()}`,
      masterweeks,
    });
  }

  async getPatientMasterweeksAndOtherDetails() {
    const params = { patientId: this.id };
    const promise1 =
        this.callServiceForRemoteObjects('/masterweek/get_list_for_patient_profile', params);
    const promise2 = this.callServiceForObjects('/caregiver/get_id_names');
    const results = await Promise.all([promise1, promise2]);

    this.setState({
      tableKey: `${Date.now()}_${Math.random()}`,
      masterweeks: results[0],
      caregivers: results[1],
    });
  }

  onAddClick() {
    this.setState({
      adding: true,
    });
  }

  onAddSuccess() {
    this.setState({
      adding: false,
    });

    this.getPatientMasterweeks();
  }

  onAddCancel() {
    this.setState({
      adding: false,
    });
  }

  onDeleteSuccess() {
    this.getPatientMasterweeks();

    // Refresh calender in case some visits have been deleted.
    this.props.onDeleteMasterweekSuccess();
  }

  onUpdateSuccess() {
    this.getPatientMasterweeks();

    // Refresh calender in case some visits have been deleted.
    this.props.onUpdateMasterweekSuccess();
  }

  renderContent() {
    const {
      contracts,
      servicesByCompany,
      onDeleteMasterweekSuccess,
      onUpdateMasterweekSuccess,
      ...layoutProps
    } = this.props;
    const { adding, tableKey, masterweeks, caregivers } = this.state;

    return (
      <FlexColContainer
        {...layoutProps}
        padding="20px 20px"
      >
        <FlexRowContainer
          width="match_parent"
          height="wrap_content"
          // margin="0 0 4px 0"
          justifyContent="space-between"
          alignItems="center"
        >
          <CustomButton
            width="150px"
            height="34px"
            backgroundColor="green_haze"
            fontSize="14px"
            type="primary"
            onClick={this.onAddClick}
          >
            ADD NEW ITEM
            <Icon type="plus" />
          </CustomButton>

          <ChangeHistoriesButton
            width="wrap_content"
            height="wrap_content"
            title="Change History"
            table="Masterweek"
            patientId={Number(this.id)}
          />
        </FlexRowContainer>

        {adding &&
          <PatientMasterweek
            width="match_parent"
            height="wrap_content"
            margin="0 0 40px 0"
            masterweek={null}
            caregivers={caregivers}
            contracts={contracts}
            servicesByCompany={servicesByCompany}
            onAddSuccess={this.onAddSuccess}
            onAddCancel={this.onAddCancel}
            onDeleteSuccess={this.onDeleteSuccess}
            onUpdateSuccess={this.onUpdateSuccess}
          />
        }

        {masterweeks.map(m => (
          <PatientMasterweek
            key={`${tableKey}_${m.getId()}`}
            width="match_parent"
            height="wrap_content"
            margin="0 0 40px 0"
            masterweek={m}
            caregivers={caregivers}
            contracts={contracts}
            servicesByCompany={servicesByCompany}
            onAddSuccess={this.onAddSuccess}
            onAddCancel={this.onAddCancel}
            onDeleteSuccess={this.onDeleteSuccess}
            onUpdateSuccess={this.onUpdateSuccess}
          />
        ))}
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
PatientMasterweeks.propTypes = propTypes;

export default PatientMasterweeks;
